import React from 'react'
import type { PresentationBlock } from 'paintscout'

import { ButtonSelectOption, ButtonOption } from '../../components'

import LooksOneIcon from '@material-ui/icons/LooksOne'
import LooksTwoIcon from '@material-ui/icons/LooksTwo'
import Looks3Icon from '@material-ui/icons/Looks3'
import Looks4Icon from '@material-ui/icons/Looks4'
import AddIcon from '@material-ui/icons/Add'

interface GalleryOptionsProps {
  block: PresentationBlock
  handleOptionFieldChange: (field: string, value: any) => void
}

function GalleryOptions(props: GalleryOptionsProps) {
  const { block, handleOptionFieldChange } = props
  const { columns, files } = block.fields

  const handleNewFile = () => {
    const newFiles = [...files]
    newFiles.push({ tempKey: 'tempKey' + new Date().getTime(), type: 'upload' })
    handleOptionFieldChange('fields.files', newFiles)
  }

  const options = [
    {
      Component: (
        <ButtonSelectOption
          label={'Columns'}
          value={columns}
          buttons={[
            { icon: <LooksOneIcon />, value: 1 },
            { icon: <LooksTwoIcon />, value: 2 },
            { icon: <Looks3Icon />, value: 3 },
            { icon: <Looks4Icon />, value: 4 }
          ]}
          onChange={(value) => handleOptionFieldChange('fields.columns', value)}
        />
      ),
      tab: 'content'
    },
    {
      Component: <ButtonOption label={'Add Item'} buttons={[{ icon: <AddIcon />, onClick: handleNewFile }]} />,
      tab: 'content'
    }
  ]

  return options
}

export default GalleryOptions
